'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
Entry.VirtualScroll = /*#__PURE__*/function () {
  function VirtualScroll() {
    var dom = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
    var option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, VirtualScroll);
    var itemHeight = option.itemHeight,
      dataWrapper = option.dataWrapper,
      data = option.data,
      groupSize = option.groupSize;
    this.dom = dom;
    this.parentDom = dom.parentElement;
    this._currGroup = -1;
    this.scrollTop = 0;
    this.data = data || [];
    this.eventData = [];
    this._groupSize = groupSize;
    this._itemHeight = itemHeight || 0;
    this.dataWrapper = dataWrapper;
    this.scroll = this.scroll.bind(this);
    this.parentDom.addEventListener('scroll', _.throttle(this.scroll, 16));
  }
  return (0, _createClass2["default"])(VirtualScroll, [{
    key: "groupSize",
    get: function get() {
      if (this._groupSize) {
        return this._groupSize;
      }
      if (this._itemHeight) {
        this._groupSize = parseInt(this.height / this._itemHeight * 1.5, 10);
        return this._groupSize;
      }
      var itemMinHeight = 15;
      return Math.max(this.height / itemMinHeight, 1);
    }
  }, {
    key: "itemHeight",
    get: function get() {
      if (!this._itemHeight && this.data.length) {
        var dom = this.convertElement(this.wrap([this.data[0]]));
        this.dom.appendChild(dom);
        this._itemHeight = dom.offsetHeight;
        $(dom).remove();
      }
      return this._itemHeight || this.height;
    }
  }, {
    key: "currGroup",
    get: function get() {
      return parseInt(this.parentDom.scrollTop / this.groupHeight, 10);
    }
  }, {
    key: "groupHeight",
    get: function get() {
      return this.itemHeight * this.groupSize;
    }
  }, {
    key: "beforeHeight",
    get: function get() {
      return Math.max((this.currGroup - 1) * this.groupHeight, 0);
    }
  }, {
    key: "afterHeight",
    get: function get() {
      var dataLength = this.data.length;
      var shownDataCount = Math.min((this.currGroup + 2) * this.groupSize, dataLength);
      return (dataLength - shownDataCount) * this.itemHeight;
    }
  }, {
    key: "height",
    get: function get() {
      return this.dom.offsetHeight || 1;
    }
  }, {
    key: "show",
    value: function show() {
      var beforeSpace = /* html */"<div style='height:".concat(this.beforeHeight, "px'></div>");
      var afterSpace = /* html */"<div style='height:".concat(this.afterHeight, "px'></div>");
      var data = this.getData(this.currGroup);
      $(this.dom).empty();
      this.dom.innerHTML = this.combineItems(beforeSpace, this.wrap(data), afterSpace);
    }
  }, {
    key: "scroll",
    value: function scroll() {
      if (this.currGroup === this._currGroup) {
        return;
      }
      this._currGroup = this.currGroup;
      this.show();
    }
  }, {
    key: "wrap",
    value: function wrap(data) {
      if (!this.dataWrapper) {
        return data;
      }
      return this.dataWrapper.replace(/\{(\d+)\}/g, this.arrayToString(data));
    }
  }, {
    key: "arrayToString",
    value: function arrayToString(arr) {
      var st = '';
      arr.forEach(function (item) {
        st += item;
      });
      return st;
    }
  }, {
    key: "getData",
    value: function getData() {
      var currGroup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : -1;
      if (currGroup === -1) {
        return this.data;
      }
      var startIndex = Math.max((currGroup - 1) * this.groupSize, 0);
      var endIndex = (currGroup + 2) * this.groupSize;
      return this.data.slice(startIndex, endIndex);
    }
  }, {
    key: "combineItems",
    value: function combineItems() {
      var htmlText = '';
      for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
      }
      items.forEach(function (item) {
        if (item instanceof Array) {
          item.forEach(function (html) {
            htmlText += html;
          });
        } else if (typeof item === 'string') {
          htmlText += item;
        }
      });
      return htmlText;
    }
  }, {
    key: "convertElement",
    value: function convertElement(html) {
      var wrapper = document.createElement('div');
      wrapper.innerHTML = html;
      return wrapper.children[0];
    }
  }, {
    key: "append",
    value: function append(item) {
      this.data.push(item);
    }
  }, {
    key: "remove",
    value: function remove() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.data.length - 1;
      this.data.splice(index, 1);
    }
  }, {
    key: "assignData",
    value: function assignData(data) {
      delete this.data;
      this.data = data;
    }
  }]);
}();